import { gql } from "@apollo/client"
import { RESPONSE_SET_FIELDS } from "./responseSetFragment"

const PROCESS_STEP_FIELDS = gql`
  fragment ProcessStepFields on ProcessStep {
    ... on CommonProcessStep {
      id
      name
      description
      responseType
      responseMandatory
      uploads {
        id
        key
        fileName
        fileGroup
        fileSize
      }
      hasScoring
      isCollapsedByDefault
      hasExclusions
      exclusions {
        id
      }
      format {
        unit
        decimals
      }
      repeatable
    }
    ... on NumberProcessStep {
      id
      name
      description
      responseType
      responseMandatory
      uploads {
        id
        key
        fileName
        fileGroup
        fileSize
      }
      hasScoring
      hasExclusions
      exclusions {
        id
      }
      format {
        unit
        decimals
      }
      logic {
        range
        lowerValue
        upperValue
        outcomes {
          type
          steps
        }
      }
      canEnterManually
      canUseDevice
      canUseSensor
      repeatable
    }
    ... on MultipleChoiceProcessStep {
      id
      name
      description
      responseType
      responseMandatory
      responseSet {
        ...ResponseSetFields
      }
      scoring {
        response
        score
        noScore
        failure
      }
      canFail
      logic {
        range
        textValues
        outcomes {
          type
          steps
        }
      }
      uploads {
        id
        key
        fileName
        fileGroup
        fileSize
      }
      hasScoring
      hasExclusions
      exclusions {
        id
      }
      repeatable
    }
    ... on ProcessProcessStep {
      id
      name
      description
      responseType
      responseMandatory
      process {
        id
        name
        stepCount
        createdAt
        updatedAt
      }
      canFail
      hasScoring
      hasExclusions
      exclusions {
        id
      }
      repeatable
    }
    ... on RandomizerProcessStep {
      id
      name
      description
      responseType
      responseMandatory
      randomizerItems
      randomizerItemName
      logic {
        range
        textValues
        outcomes {
          type
          steps
        }
      }
      uploads {
        id
        key
        fileName
        fileGroup
        fileSize
      }
      hasExclusions
      exclusions {
        id
      }
      repeatable
    }
    ... on SelectionProcessStep {
      id
      name
      description
      responseType
      responseMandatory
      selection {
        selectFrom
        allowMultiple
        enableBatchEntry
        customItems
      }
      logic {
        range
        textValues
        outcomes {
          type
          steps
        }
      }
      uploads {
        id
        key
        fileName
        fileGroup
        fileSize
      }
      hasExclusions
      exclusions {
        id
      }
      repeatable
    }
    ... on TouchpointProcessStep {
      id
      name
      description
      responseType
      responseMandatory
      uploads {
        id
        key
        fileName
        fileGroup
        fileSize
      }
      allowedTouchpoints {
        id
        nfcId
      }
      hasExclusions
      exclusions {
        id
      }
      repeatable
    }
  }
  ${RESPONSE_SET_FIELDS}
`

export { PROCESS_STEP_FIELDS }
